/**
 * Generated by orval v6.10.3 🍺
 * Do not edit manually.
 * CMS-POC WebAPI
 * OpenAPI spec version: 1.0
 */
import axios from 'axios'
import type {
  AxiosRequestConfig,
  AxiosResponse,
  AxiosError
} from 'axios'
import {
  useQuery,
  useMutation
} from '@tanstack/react-query'
import type {
  UseQueryOptions,
  UseMutationOptions,
  QueryFunction,
  MutationFunction,
  UseQueryResult,
  QueryKey
} from '@tanstack/react-query'
import type {
  ScheduleListMasters,
  ErrorInfo,
  ScheduleList,
  ScheduleListSearchConditions,
  BinaryFile,
  ScheduleListDownloadList
} from '.././model'


/**
 * 日程一覧に必要なマスタを一括取得して返す。

 * @summary 日程一覧マスタ一括取得
 */
export const getScheduleListMasters = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<ScheduleListMasters>> => {
    return axios.get(
      `/scheduleList/masters`,options
    );
  }


export const getGetScheduleListMastersQueryKey = () => [`/scheduleList/masters`];

    
export type GetScheduleListMastersQueryResult = NonNullable<Awaited<ReturnType<typeof getScheduleListMasters>>>
export type GetScheduleListMastersQueryError = AxiosError<ErrorInfo>

export const useGetScheduleListMasters = <TData = Awaited<ReturnType<typeof getScheduleListMasters>>, TError = AxiosError<ErrorInfo>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getScheduleListMasters>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetScheduleListMastersQueryKey();

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getScheduleListMasters>>> = ({ signal }) => getScheduleListMasters({ signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof getScheduleListMasters>>, TError, TData>(queryKey, queryFn, queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

/**
 * 日程一覧を取得する
 * @summary 日程一覧取得
 */
export const postScheduleListSearch = (
    scheduleListSearchConditions: ScheduleListSearchConditions, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<ScheduleList>> => {
    return axios.post(
      `/scheduleList/search`,
      scheduleListSearchConditions,options
    );
  }



    export type PostScheduleListSearchMutationResult = NonNullable<Awaited<ReturnType<typeof postScheduleListSearch>>>
    export type PostScheduleListSearchMutationBody = ScheduleListSearchConditions
    export type PostScheduleListSearchMutationError = AxiosError<ErrorInfo>

    export const usePostScheduleListSearch = <TError = AxiosError<ErrorInfo>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postScheduleListSearch>>, TError,{data: ScheduleListSearchConditions}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postScheduleListSearch>>, {data: ScheduleListSearchConditions}> = (props) => {
          const {data} = props ?? {};

          return  postScheduleListSearch(data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof postScheduleListSearch>>, TError, {data: ScheduleListSearchConditions}, TContext>(mutationFn, mutationOptions)
    }
    /**
 * 日程一覧をExcelファイルに出力してダウンロードする。日程一覧画面での表示順で出力する。
 * @summary 日程一覧ダウンロード（エクスポート）
 */
export const postScheduleListDownload = (
    scheduleListDownloadList: ScheduleListDownloadList, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<BinaryFile>> => {
    return axios.post(
      `/scheduleList/download`,
      scheduleListDownloadList,options
    );
  }



    export type PostScheduleListDownloadMutationResult = NonNullable<Awaited<ReturnType<typeof postScheduleListDownload>>>
    export type PostScheduleListDownloadMutationBody = ScheduleListDownloadList
    export type PostScheduleListDownloadMutationError = AxiosError<ErrorInfo>

    export const usePostScheduleListDownload = <TError = AxiosError<ErrorInfo>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postScheduleListDownload>>, TError,{data: ScheduleListDownloadList}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postScheduleListDownload>>, {data: ScheduleListDownloadList}> = (props) => {
          const {data} = props ?? {};

          return  postScheduleListDownload(data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof postScheduleListDownload>>, TError, {data: ScheduleListDownloadList}, TContext>(mutationFn, mutationOptions)
    }
    